import UserRole from "@/model/UserRole";

/** Where to go "back" to from a property page: the company tab for admins, "my properties" for hosts. */
function propertyListPath(role: UserRole, companyId?: string): string {
  if (role === "ADMIN") {
    return companyId ? `/companies/${companyId}/properties` : "/properties";
  }
  return "/my-properties";
}

export default propertyListPath;
